"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHumanReadableString = void 0;
function ordinalSuffix(num) {
    const tenth = num % 10;
    const hundredth = num % 100;
    if (tenth === 1 && hundredth !== 11) {
        return `${num}st`;
    }
    if (tenth === 2 && hundredth !== 12) {
        return `${num}nd`;
    }
    if (tenth === 3 && hundredth !== 13) {
        return `${num}rd`;
    }
    return `${num}th`;
}
const weekdayNames = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
};
const generateHumanReadableString = (config) => {
    if (config.recurringDateConfigs.length === 0) {
        return '';
    }
    if (Array.isArray(config.recurringDateConfigs[0])) {
        return 'Custom schedule';
    }
    const firstConfig = config.recurringDateConfigs[0];
    const offset = firstConfig.offset;
    const offsetString = offset && offset.days !== 0
        ? `${Math.abs(offset.days)} ${offset.dayUnit === 'businessDay' ? 'business' : 'calendar'} day${Math.abs(offset.days) > 1 ? 's' : ''} ${offset.days < 0 ? 'before' : 'after'} `
        : '';
    const period = firstConfig.period;
    const cadence = firstConfig.cadence;
    const frequency = `${period}${cadence > 1 ? `, every ${cadence} ${period}s` : ''}`;
    switch (firstConfig.type) {
        case 'startOf':
            return `${offsetString}the start of each ${frequency}`;
        case 'endOf':
            return `${offsetString}the end of each ${frequency}`;
        case 'calendarDate': {
            const dayOfMonth = new Date(firstConfig.startDate).getUTCDate();
            return `${offsetString}the ${ordinalSuffix(dayOfMonth)} of each ${frequency}`;
        }
        case 'weekday': {
            const weekdayList = firstConfig.weekdays
                .map((w) => weekdayNames[w])
                .join(', ');
            return `${offsetString}every ${weekdayList}, each ${frequency}`;
        }
        case 'weekdayByOccurrence': {
            const weekdayList = firstConfig.weekdays
                .map((w) => weekdayNames[w])
                .join(', ');
            return `${offsetString}the ${ordinalSuffix(firstConfig.occurrence)} ${weekdayList} of each ${frequency}`;
        }
        default:
            return '';
    }
};
exports.generateHumanReadableString = generateHumanReadableString;
//# sourceMappingURL=humanReadable.js.map